// @ts-ignore-next-line
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';

const noop = () => {};

const SafeTawkMessenger = (props: any) => (
  <TawkMessengerReact
    // Safe defaults for ALL events
    onBeforeLoad={noop}
    onLoad={noop}
    onStatusChange={noop}
    onChatMaximized={noop}
    onChatMinimized={noop}
    onChatHidden={noop}
    onChatStarted={noop}
    onChatEnded={noop}
    onPrechatSubmit={noop}
    onOfflineSubmit={noop}
    onChatMessageVisitor={noop}
    onChatMessageAgent={noop}
    onChatMessageSystem={noop}
    onAgentJoinChat={noop}
    onAgentLeaveChat={noop}
    onChatSatisfaction={noop}
    onVisitorNameChanged={noop}
    onFileUpload={noop}
    onTagsUpdated={noop}
    onUnreadCountChanged={noop}
    {...props} // allow overrides (propertyId, widgetId, or custom handlers)
  />
);

export default SafeTawkMessenger;
